<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales of Tampa</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="70px"/>
<col width="320px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Chapter 1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Early Days</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Old City Cemetery</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">The Spirits of the Hotel Floridan</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">The Tampa Theater</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Duckweed Urban Market</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">A Clock Named Hortense</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">The Old Tampa Book Company</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">The Sykes Building</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">The Sad Singer</span></td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">More University Ghosts</span></td></tr>
<tr><td><span href="#/Chapter11#C11" title="Link target outside of Sample">Chapter 11.</span></td><td><span href="#/Chapter11#C11" title="Link target outside of Sample">Over the Bay</span></td></tr>
<tr><td><span href="#/Chapter12#C12" title="Link target outside of Sample">Chapter 12.</span></td><td><span href="#/Chapter12#C12" title="Link target outside of Sample">Ghosts in Nearby Places</span></td></tr>
<tr><td><span href="#/Chapter13#C13" title="Link target outside of Sample">Chapter 13.</span></td><td><span href="#/Chapter13#C13" title="Link target outside of Sample">The Sulphur Springs Water Tower</span></td></tr>
<tr><td><span href="#/Chapter14#C14" title="Link target outside of Sample">Chapter 14.</span></td><td><span href="#/Chapter14#C14" title="Link target outside of Sample">Tampa Ghosts</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?674eb826